<script setup lang="ts">
  import { useModalStack } from '@/common/components/modal/ModalStack.api'
  import { useRouter } from 'vue-router'
  import ModalStack from '@/common/components/modal/ModalStack.vue'

  // The modal stack emulates a child-router. It renders the component of a child
  // route inside a modal. The stack is kept in the vuex store.
  const router = useRouter()

  const { close, stack } = useModalStack(router)
</script>

<template>
  <ModalStack :stack="stack" @backdropClick="close">
    <template #default="{ item }">
      <component :is="item.components.default" v-bind="item.props" class="h-full bg-gray-50" />
    </template>
  </ModalStack>
</template>

